export const categories = [
  {
    slug: "entertainment",
    name: "娱乐人物",
    en: "Entertainment",
    icon: "ri-user-star-line",
    desc: "演员、艺人相关的公开话题与出行、合作、社交动态线索汇总。",
    count: 326,
  },
  {
    slug: "screen",
    name: "影视综艺",
    en: "Screen",
    icon: "ri-clapperboard-line",
    desc: "剧集、电影、综艺播出前后的番位、剪辑、番外与口碑争议梳理。",
    count: 412,
  },
  {
    slug: "music",
    name: "音乐现场",
    en: "Music",
    icon: "ri-music-2-line",
    desc: "单曲、专辑、演出现场相关的旋律相似、修音、退票等讨论汇总。",
    count: 238,
  },
  {
    slug: "livestream",
    name: "网红主播",
    en: "Livestream",
    icon: "ri-live-line",
    desc: "直播间口误、带货翻车、切片传播与主播回应的事件索引。",
    count: 507,
  },
  {
    slug: "business",
    name: "商业风云",
    en: "Business",
    icon: "ri-briefcase-4-line",
    desc: "品牌代言、解约、股权变更与商业合作纠纷的公开信息整理。",
    count: 189,
  },
  {
    slug: "sports",
    name: "体育竞技",
    en: "Sports",
    icon: "ri-run-line",
    desc: "赛事判罚、退赛、状态波动与场外言论引发的讨论线索。",
    count: 154,
  },
];